import { CarNavigationHistoryPathType } from '../types';

import { CAR_NAVIGATION_HISTORY_PATH_TYPES } from '../constants';

export const checkIsAllCarNavigationHistoryPathTypes = (value: CarNavigationHistoryPathType) => (
  value === CAR_NAVIGATION_HISTORY_PATH_TYPES.all
);
